import React from 'react';

const Empty = () => {
    return (
        <div className="empty">
            <div>
                <img src="//www.jawa.gg/assets/_new/empty-product.jpg" alt="" />
                <span>No products available</span>
                <button className="btn">Add product</button>
            </div>
        </div>
    )
}

export default Empty;